<template>
  <!--
      	作者：zhuchangtao
      	时间：2021-03-30
      	描述：题库-任务列表
      -->
  <div>
     <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
       <el-form-item label="标题"><el-input size="small" v-model="searchForm.task_name" placeholder="请输入标题"></el-input></el-form-item>

       <el-form-item label="类型">
         <el-select size="small" v-model="searchForm.task_type" placeholder="请选择">
           <el-option label="全部" value=""></el-option>
           <el-option label="单人项目" value="10"></el-option>
           <el-option label="团队项目" value="20"></el-option>


         </el-select>
       </el-form-item>

       <el-form-item label="起始时间">
         <div class="block">
           <span class="demonstration"></span>
           <el-date-picker
             size="small"
             v-model="searchForm.create_time"
             type="daterange"
             value-format="yyyy-MM-dd"
             range-separator="至"
             start-placeholder="开始日期"
             end-placeholder="结束日期"
           ></el-date-picker>
         </div>
       </el-form-item>
       <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>

     </el-form>
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addtask" v-auth="'/task/task/add'">添加任务</el-button></div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="task_id" label="项目ID" width="60"></el-table-column>

        <el-table-column prop="task_name" label="项目标题">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.task_name">{{scope.row.task_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="task_type_text" label="项目类型" ></el-table-column>
        <el-table-column prop="start_time_text" label="开始时间"></el-table-column>
        <el-table-column prop="end_time_text" label="结束时间"></el-table-column>
        <el-table-column prop="task_status_text" label="状态" ></el-table-column>
        <el-table-column prop="create_time" label="添加时间" ></el-table-column>

        <el-table-column prop="name" label="操作" >
          <template slot-scope="scope">
            <el-button @click="edittask(scope.row)" type="text" size="small" v-auth="'/task/task/edit'">编辑</el-button>
            <el-button @click="taskclocklist(scope.row)" type="text" size="small" v-auth="'/task/clock/index'">打卡列表</el-button>
            <el-button @click="ranklist(scope.row)" type="text" size="small" v-auth="'/task/rank/index'">排行榜</el-button>
            <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/task/task/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import taskApi from '@/api/task.js';

export default {
  components: {

  },
  data() {
    return {
      /*横向表单数据模型*/
      searchForm: {
        task_name: "",
        task_type:'',
        create_time: ''
      },
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
    /*获取任务列表*/
    this.getTableList();
  },
  methods: {
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },
    /*获取任务列表*/
    getTableList() {
      let self = this;
      let Params = this.searchForm;
      Params.page = self.curPage;
      taskApi.taskList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加任务*/
    addtask() {
      this.$router.push({
        path: '/task/task/add'
      });
    },

    /*编辑任务*/
    edittask(row) {
      let params = row.task_id;
      this.$router.push({
        path: '/task/task/edit',
        query: {
          task_id: params
        }
      });
    },
    /*删除任务*/
    deleteClick(row) {

      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {

          self.loading = true;
          taskApi.deleteTask({task_id: row.task_id},true).then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();

            }).catch(error => {});

        }).catch(() => {});
    },

    /*打卡列表*/
    taskclocklist(row) {
      let params = row.task_id;
      this.$router.push({
        path: '/task/clock/index',
        query: {
          task_id: params
        }
      });
    },
    /*排行榜*/
    ranklist(row) {
      let params = row.task_id;
      this.$router.push({
        path: '/task/rank/index',
        query: {
          task_id: params
        }
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getTableList();
    },









  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/task/task/index.vue